(ns hai.home.desktop
  "Home — daily dashboard page. Renders the wide (desktop) body; the narrow body
   lives in [[hai.home.mobile]] and is selected by the dispatcher via the
   route's :mobile-view. Which cards show is the platform's call, through
   [[hai.mini-apps.data]]; where each one sits is this page's."
  (:require
   [hai.home.calendar :as calendar-state]
   [hai.home.desktop.mini-apps.calendar :as calendar]
   [hai.home.desktop.mini-apps.clock :as clock]
   [hai.home.desktop.mini-apps.notes :as notes]
   [hai.home.desktop.mini-apps.progress :as progress]
   [hai.home.desktop.mini-apps.tasks :as tasks]
   [hai.home.desktop.mini-apps.tips-and-tricks :as tips-and-tricks]
   [hai.home.desktop.views :as views]
   [hai.home.events]
   [hai.mini-apps.data :as mini-apps]
   [hai.ui.components :as c]
   [hai.ui.rf-sugar :refer [<s]]))

(defn- slot
  [panel mini-app]
  (when mini-app
    [panel mini-app]))

(defn- desktop-body []
  (let [mini-apps @(<s [::mini-apps/by-tool])
        loaded?   @(<s [::mini-apps/loaded?])
        loading?  @(<s [::calendar-state/loading?])
        error?    @(<s [::calendar-state/error?])]
    [views/page-desktop
     (cond
       (or (not loaded?) loading?)
       [c/Flex {:justify "center" :py "9"}
        [c/Spinner {:size "3"}]]

       error?
       [c/Flex {:justify "center" :py "9"}
        [c/Text {:color "red" :size "3"} "Failed to load calendar events. Please try again."]]

       :else
       [:<>
        [views/top-row
         ;; Tips and tricks ride under the clock in the left (auto-width) column.
         [:div
          [slot clock/panel (:clock mini-apps)]
          [slot tips-and-tricks/panel (:tips-and-tricks mini-apps)]]
         [slot notes/panel (:notes mini-apps)]]
        [slot progress/panel (:progress mini-apps)]
        [views/two-columns
         [slot calendar/panel (:calendar mini-apps)]
         [slot tasks/panel (:tasks mini-apps)]]])]))

(defn page [_route]
  [desktop-body])
